// extracted by mini-css-extract-plugin
module.exports = {"percentageMatch":"percentageMatch_1IhM2h","percentage":"percentage_2Ovf37","percentageLabel":"percentageLabel_2tgbod"};